export default "__VITE_ASSET__BWQCR8pF__"